import React from 'react';
import { ShieldCheck, Activity, Sparkles } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const DermatologyPage = () => {
  const config = {
    badge: "Dermatology Care",
    headline: "Skin & Allergy",
    headlineItalic: "Mastery.",
    subtext: "Providing advanced clinical solutions for the most complex skin and ear health challenges in canines and felines.",
    image: "/images/services/dermatology.png",
    imageAlt: "Veterinary Dermatology at Dr. Suresh Pet Care — Skin & Allergy Treatment",
    stats: [
      { value: 1500, suffix: '+', label: 'Skin Cases Treated' },
      { value: 92, suffix: '%', label: 'Allergy Resolution Rate' },
      { value: 6, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Allergy Testing",
        icon: <Activity size={28} />,
        desc: "Comprehensive diagnostic protocols identifying environmental and food-related allergies with precision.",
        specs: ["Skin Scrapers", "Allergy Screening", "Food Trial Protocols", "Intradermal Testing"],
        color: "from-amber-500/10 to-primary/10"
      },
      {
        title: "Ear Health Unit",
        icon: <ShieldCheck size={28} />,
        desc: "Specialized management of chronic ear infections and advanced otoscopy for thorough clinical auditing.",
        specs: ["Video Otoscopy", "Ear Flush Protocols", "Cytology Analysis", "Chronic Management"],
        color: "from-primary/10 to-teal-500/10"
      },
      {
        title: "Skin Med-Care",
        icon: <Sparkles size={28} />,
        desc: "Therapeutic management of bacterial, fungal, and parasitic skin conditions with modern protocols.",
        specs: ["Medicated Baths", "Topical Therapy", "Systemic Management", "Biopsy Diagnostics"],
        color: "from-rose-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Dermatology",
    sectionItalic: "Services.",
    warningTitle: "Common Skin",
    warningItalic: "Conditions.",
    warningText: "Understanding dermatological red flags is key to preventing chronic skin infections and allergic flare-ups in your pet.",
    warnings: [
      { name: "Chronic Itching", desc: "Constant scratching, licking, or biting at the skin surface.", icon: "🐾" },
      { name: "Hair Loss", desc: "Patchy or thinning fur, often accompanied by redness or flaking.", icon: "🌀" },
      { name: "Ear Infections", desc: "Head shaking, unpleasant odor, or discharge from the ears.", icon: "👂" },
      { name: "Skin Lesions", desc: "Redness, bumps, or crusty patches developing on the skin.", icon: "🔴" },
    ],
    ctaBadge: "Clinical Dermatology",
    ctaTitle: "The Dermatology",
    ctaItalic: "Expertise.",
    ctaText: "Led by Dr. T Suresh Babu, our dermatology unit focuses on long-term relief from chronic itching, infections, and allergic flare-ups in Hyderabad.",
    ctaBtn: "Book Skin Audit",
    seoText: "Professional pet dermatology and allergy testing in Hyderabad. Dog skin infection treatment at Dr. Suresh Pet Care. Specialized ear health management for pets.",
    glowColor: "amber-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Dermatology & Skin Care"
        description="Specialized treatment for pet allergies, skin infections, and ear diseases at Dr. Suresh Pet Care. Modern dermatological diagnostics in Hyderabad."
        canonical="/dermatology"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default DermatologyPage;
